export default {
  base: {
    width: '100%',
    cursor: 'pointer',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
    borderRadius: '2px'
  },
  draggingStyles: {
    opacity: '0.3',
    background: '#6B45C9',
    zIndex: 2
  }
}



// WEBPACK FOOTER //
// ./src/components/GifCard/styles.js